import React, { Component } from 'react';
import '../../css/tips.css';
import classNames from 'classnames';
import { translate } from '../../utils/lang-adapters';

class MatchTips extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };
    this.data = this.doMath();
  }

  doMath() {
    let totalTipsOT0 = 0;
    let totalTipsOT1 = 0;
    let topVotedOT0Odd = 0;
    let topVotedOT0Tips = 0;
    let topVotedOT0Runner = "";
    let lowerOT0Odd = 0;
    let lowerOT0Runner = "";
    let valueFinalOdd = 0;
    let winnerOT0Runner = "";
    let winnerOT0Odd = 0;
    let winnerOT0Tips = 0;

    this.props.data.tips.forEach((tip, index) => {

      if (tip.ot_id === 0) {
        totalTipsOT0 = totalTipsOT0 + tip.tips;
        if (tip.tips > topVotedOT0Tips) {
          topVotedOT0Tips = tip.tips;
          topVotedOT0Odd = tip.value;
          topVotedOT0Runner = tip.runner;
        }
        if (tip.ot_id === 0 && tip.winner === true) {
          winnerOT0Tips = tip.tips;
          winnerOT0Runner = tip.runner;
          winnerOT0Odd = tip.value;
        }
        if (index === 0) {
          lowerOT0Odd = tip.value;
          lowerOT0Runner = tip.runner
        } else if (tip.value < lowerOT0Odd) {
          lowerOT0Odd = tip.value;
          lowerOT0Runner = tip.runner;
        }
      } else if (tip.ot_id === 1) {
        totalTipsOT1 = totalTipsOT1 + tip.tips;
      }
    })
    return {
      totalTipsOT0,
      totalTipsOT1,
      topVotedOT0Odd,
      topVotedOT0Tips,
      topVotedOT0Runner,
      lowerOT0Odd,
      lowerOT0Runner,
      valueFinalOdd,
      winnerOT0Runner,
      winnerOT0Odd,
      winnerOT0Tips,
    }
  }

  renderTipsArrayMarket0() {
    let sortedArray = [{}, {}, {}];
    this.props.data.tips.forEach((each) => {
      if (each.ot_id === 0) {
        if (each.runner === 'The Draw') {
          sortedArray[1] = each;
        } else if (each.runner === this.props.data.team_A_name) {
          sortedArray[0] = each;
        } else if (each.runner === this.props.data.team_B_name) {
          sortedArray[2] = each;
        } else if (Object.keys(sortedArray[0]).length === 0) {
          sortedArray[0] = each;
        } else {
          sortedArray[2] = each;
        }
      }
    })
    return (
      sortedArray.map((tip, index) => {
        if (tip.ot_id === 0) {
          let selectionTipsPercentage;
          if (this.data.totalTipsOT0 === 0) {
            selectionTipsPercentage = ((1 / tip.value) * 100);
          } else {
            selectionTipsPercentage = ((tip.tips * 100) / this.data.totalTipsOT0);
          }
          return (
            <div key={index} className={classNames("tips-values-home", tip.winner && "iswinner")}>
              <a className="" href="https://www.academiadasapostas.com/redirect/betclic" target="_blank" rel="noopener noreferrer">
                <div className="total-values">
                  <div className="value-runner">{
                    translate(tip.runner)}</div>
                  <div className="values">{tip.value}</div>
                </div>
                <div className="bar-stats-odds" align="left">
                  <div className={classNames("bar-od-market1", selectionTipsPercentage)} style={{ width: selectionTipsPercentage + '%' }}>{parseInt(selectionTipsPercentage)}%</div>
                </div>
              </a>
            </div>
          )
        } else {
          return null
        }
      })
    )
  }

  renderTipsArrayMarket1() {
    return (
      this.props.data.tips.map((tip, index) => {
        if (tip.ot_id === 1) {
          let selectionTipsPercentage;
          if (this.data.totalTipsOT1 === 0) {
            selectionTipsPercentage = ((1 / tip.value) * 100);
          } else {
            selectionTipsPercentage = ((tip.tips * 100) / this.data.totalTipsOT1);
          }
          return (
            <div key={index} className={classNames("tips-values-away", tip.winner && "iswinner")}>
              <a href="https://www.academiadasapostas.com/redirect/betclic" target="_blank" rel="noopener noreferrer">
                <div className="total-values">
                  <div className="value-runner">{
                    translate(tip.runner)
                  }</div>
                  <div className="values">{tip.value}</div>
                </div>
                <div className="bar-stats-odds" align="left">
                  <div className={classNames("bar-od-market2", selectionTipsPercentage)} style={{ width: selectionTipsPercentage + '%' }}>{parseInt(selectionTipsPercentage)}%</div>
                </div>
              </a>
            </div>
          )
        }
        else {
          return null
        }
      })
    )
  }

  renderWinner() {
    if (this.data.winnerOT0Tips === 0) {
      return (
        <div className="tips-div">
          <a href="https://www.academiadasapostas.com/redirect/betclic" target="_blank" rel="noopener noreferrer">
            <p className="msgutilizadores"><strong>Ninguém acertou </strong> que {translate(this.data.winnerOT0Runner)} <strong>ganhava</strong>, com <strong>10€</strong> podias ter ganho <strong>{parseInt(this.data.winnerOT0Odd * 10)}€</strong>,</p>
            <p className="msgutilizadores">não percas a tua oportunidade e <strong>regista-te já!</strong></p>
          </a>
        </div>
      )
    } else {
      return (
        <div className="tips-div">
          <a href="https://www.academiadasapostas.com/redirect/betclic" target="_blank" rel="noopener noreferrer">
            <p className="msgutilizadores"><strong>{parseInt(this.data.winnerOT0Tips / this.data.totalTipsOT0 * 100)}%</strong> acertou que {translate(this.data.winnerOT0Runner)} <strong>ganhou</strong>, com <strong>10€</strong> ganharam <strong>{parseInt(this.data.winnerOT0Odd * 10)}€</strong>,</p>
            <p className="msgutilizadores">não percas a tua oportunidade e <strong>regista-te já!</strong></p>
          </a>
        </div>
      )
    }
  }


  render() {
    let topOT0Runner;
    let topPercentageTipsOT0;
    let valueFinalOdd;

    if (this.data.totalTipsOT0 === 0) {
      // When we did not have tips show the percentage of the minor odd
      topPercentageTipsOT0 = parseInt(1 / this.data.lowerOT0Odd * 100);
      topOT0Runner = this.data.lowerOT0Runner;
      valueFinalOdd = parseInt(this.data.lowerOT0Odd * 10);
    } else {
      topPercentageTipsOT0 = parseInt(this.data.topVotedOT0Tips / this.data.totalTipsOT0 * 100);
      topOT0Runner = this.data.topVotedOT0Runner;
      valueFinalOdd = parseInt(this.data.topVotedOT0Odd * 10)
    }
    return this.data.topVotedOT0Runner === '' ? null : (
      <div className="tips-div-div">
        <div className="title-tips">
          <div className="icons">
            <span className="ball">
              <img src="/img/tips.svg" alt="match tips" width="20" />
            </span>
            <h2>Tips</h2>
          </div>
        </div>
        <div>
          {
            this.data.winnerOT0Runner !== '' ?
              this.renderWinner()
              :
              <div className="tips-div">
                <a href="https://www.academiadasapostas.com/redirect/betclic" target="_blank" rel="noopener noreferrer">
                  <p className="msgutilizadores"><strong>{topPercentageTipsOT0}%</strong> dos utilizadores acham que {translate(topOT0Runner)} <strong>vai ganhar</strong>,</p>
                  <p className="msgutilizadores">com <strong>10€</strong> podes ganhar <strong>{valueFinalOdd}€</strong></p>
                </a>
              </div>
          }
        </div>
        <p className="tipsot">Resultado<span className="Warn-tip" data-title="As odds podem ter variações">*</span></p>
        <div className="tips-div-home">
          {
            this.renderTipsArrayMarket0()
          }
        </div>
        <p className="tipsot">Total de Golos Mais/Menos</p>
        <div className="tips-div-away">
          {
            this.renderTipsArrayMarket1()
          }
        </div>
      </div>
    )
  }
}
export default MatchTips;